import React, { useContext, useEffect, useState } from "react";
import "./panvel.css";
import { useLayerFunc } from "../Main/layerFunc";
import { GlobalContext } from "../../App";

function KhargharWardProj() {
  const { LayerChange, TileLayerChange, handleOpen } = useLayerFunc();
  const { SetLogout } = useContext(GlobalContext);

  useEffect(() => {
    SetLogout(true);
  }, []);

  return (
    <>
      <details
        className="baseline"
       onToggle={() => handleOpen("Kharghar_Boundary")}
      >
        <summary>Kharghar-Ward</summary>
        <div className="baseline-cont">
          <div className="opt-div">
            <input
                  value="Kharghar_Boundary"
                  id="Kharghar_Boundary"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                  
                />
            <label>Boundary</label>
          </div>
          <details id="townD">
            <summary className="townS">Baseline</summary>
            <div className="town-cont">
              <div className="opt-div">
                <input
                  value="Kharghar_Road_Network"
                  id="Kharghar_Road_Network"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                />
                <label>Road</label>
              </div>
              <div className="opt-div">
                <input
                  value="Kharghar_Railway_network"
                  id="Kharghar_Railway_network"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                />
                <label>Railways</label>
              </div>
                <div className="opt-div">
                <input
                  value="Kharghar_Mangrove_Swamps"
                  id="Kharghar_Mangrove_Swamps"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                />
                <label>Mangrove Swamps</label>
              </div>
            
             
              <div className="opt-div">
                  <input
                    value="Kharghar_Tree"
                    id="Kharghar_Tree"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Tree</label>
                </div>

                <div className="opt-div">
                  <input
                    value="Kharghar_Water"
                    id="Kharghar_Water"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(
                        e.target.value,
                        e.target.id,
                        e.target.checked,
                        false,
                        true
                      )
                    }
                  />
                  <label>Waterbody</label>
                </div>
                  <div className="opt-div">
                <input
                  value="Kharghar_Total_Builtup"
                  id="Kharghar_Total_Builtup"
                  className="form-check-input check-map"
                  type="checkbox"
                  onChange={(e) =>
                    LayerChange(e.target.value, e.target.id, e.target.checked)
                  }
                />
                <label>Total Builtup</label>
              </div>
            </div>
 </details>
            <details id="townD">
              <summary className="townS">Town Planning</summary>
              <div
                className="town-cont"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyItems: "right",
                }}
              >
                <div className="opt-div">
                  <input
                    value="Kharghar_Prabhag"
                    id="Kharghar_Prabhag"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Prabhag</label>
                </div>
                 <div className="opt-div">
                  <input
                    value="Kharghar_Panvel_Jurisdiction"
                    id="Kharghar_Panvel_Jurisdiction"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Jurisdiction</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Kharghar_Village_Boundary"
                    id="Kharghar_Village_Boundary"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Village Boundary</label>
                </div>
                <div className="opt-div">
                  <input
                    value="Kharghar_Village_Survey"
                    id="Kharghar_Village_Survey"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Village survey</label>
                </div>
                
              </div>
            </details>
         

             <details id="townD">
              <summary className="townS">Builtup Change</summary>
              <div
                className="town-cont"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyItems: "right",
                }}
              >
               
                <div className="opt-div">
                  <input
                    value="Kharghar_Other_Authority"
                    id="Kharghar_Other_Authority"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Other Authority</label>
                </div>
                
                <div className="opt-div">
                  <input
                    value="Kharghar_total_builtup_jan2023"
                    id="Kharghar_total_builtup_jan2023"
                    className="form-check-input check-map"
                    type="checkbox"
                    onChange={(e) =>
                      LayerChange(e.target.value, e.target.id, e.target.checked)
                    }
                  />
                  <label>Total builtup jan2023</label>
                </div>
              </div>
            </details>

           <details id="townD">
            <summary className="townS">Images</summary>
            <div className="town-cont mb-3">
              <div className="opt-div">
                <input
                  value="Jan_2023"
                  id="Kharghar_Boundary"
                  onChange={(e) =>
                    TileLayerChange(
                      e.target.value,
                      e.target.id,
                      "Jan 2023",
                      e.target.checked
                    )
                  }
                  className="form-check-input check-map"
                  type="checkbox"
                />
                <label>Jan 2023</label>
              </div>
              <div className="opt-div">
                <input
                  value="March_2025"
                  id="Kharghar_Boundary"
                  onChange={(e) =>
                    TileLayerChange(
                      e.target.value,
                      e.target.id,
                      "March 2025",
                      e.target.checked
                    )
                  }
                  className="form-check-input check-map"
                  type="checkbox"
                />
                <label>March 2025</label>
              </div>
            </div>
          </details>
        </div>
      </details>
    </>
  );
}

export default KhargharWardProj;
